import React, { useEffect, useState } from "react";
import { useOutsideClickHook } from "utils/outsideClick";
import DropDown from "components/Dropdown";
import classes from "../style.module.scss";
import HousesSelect from "assets/images/icons/JSX/HousesSelect";
import ArrowDown from "assets/images/icons/JSX/arrow-down";

const CommUpgradeHeadBase = ({
    name,
    currentModelId,
    modelDir,
    handleSelectBaseModel
}) => {
    const { models = {}, folders = {} } = modelDir;

    const [open, toggleOpen] = useState(false);

    const ref = useOutsideClickHook(() => toggleOpen(false));

    const handleSelectModel = (modelId) => {
        toggleOpen(false);
        handleSelectBaseModel(modelId);
    };

    const [headerOptions, setHeaderOptions] = useState([]);

    useEffect(() => {
        setHeaderOptions([
            ...Object.entries(models).map(([key, value]) => ({
                label: (
                    <>
                        <HousesSelect /> {value.name}
                    </>
                ),
                className: `${classes.dropdownLabel} ${key === currentModelId ? classes.selected : ""}`,
                onClick: () => handleSelectModel(key),
            })),
        ]);
    }, [models]);

    return (
        <span className={classes.upgradeHeadBase} onClick={() => toggleOpen(!open)}>
            <span className={classes.upgradeHeadBaseLabel}>{currentModelId ? name : "No Models Found"}</span>
            {currentModelId && (
                <div ref={ref} className={classes.upgradeHeadMenuWrapper}>
                    <ArrowDown className={classes.upgradeHeadMenu} />
                    <DropDown
                        className={classes.upgradeHeadBaseDropdown}
                        open={open}
                        toggleOpen={() => toggleOpen(!open)}
                        options={headerOptions}
                    />
                </div>
            )}
        </span>
    );
};

export default CommUpgradeHeadBase;